import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=86713c72&scoped=true&"
import script from "./SignUpForm.vue?vue&type=script&lang=js&"
export * from "./SignUpForm.vue?vue&type=script&lang=js&"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=86713c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86713c72",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheInput: require('/opt/build/repo/components/basics/TheInput.vue').default,PromiseButton: require('/opt/build/repo/components/basics/PromiseButton.vue').default,TheCheckbox: require('/opt/build/repo/components/basics/TheCheckbox.vue').default,TheModal: require('/opt/build/repo/components/basics/TheModal.vue').default})
